import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "drg-name" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode(" MS "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" DRG ")
  ])
], -1)
const _hoisted_2 = { class: "drg-value" }
const _hoisted_3 = { class: "MCC-text" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-h8" }, " MCC ", -1)
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col description" }
const _hoisted_9 = { class: "row justify-start" }
const _hoisted_10 = { class: "col-1 weight" }
const _hoisted_11 = { class: "col-1 gmlos" }
const _hoisted_12 = { class: "col-1 mdc" }
const _hoisted_13 = { class: "col-1 type" }
const _hoisted_14 = { class: "col-1 reimbursement" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "drg-name" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode(" APR "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" DRG ")
  ])
], -1)
const _hoisted_16 = { class: "drg-value" }
const _hoisted_17 = { class: "MCC-text" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, " MCC ", -1)
const _hoisted_20 = { class: "col" }
const _hoisted_21 = { class: "col-1" }

import DualPane from 'components/global-common/DualPane.vue';
import { useGrouperStore } from 'stores/GrouperStore';
import { ref, Ref } from 'vue';
import { useLayoutStore } from 'stores/layout-store';
import { storeToRefs } from 'pinia';
import DisplayProperty from 'components/global-common/DisplayProperty.vue';

export interface Props {
  enableDualGrouping?: boolean,
  showApr?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GrouperInfo',
  props: {
    enableDualGrouping: { type: Boolean, default: true },
    showApr: { type: Boolean, default: false }
  },
  emits: ["secondary-expanded"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const expandSecondary: Ref<boolean> = ref(props.showApr)
const {primaryDRG, secondaryDRG} = storeToRefs(useGrouperStore());

const onSecondaryExpanded = (value: boolean) => {
  expandSecondary.value = value;
  useLayoutStore().expandCollapseApr();
  emit('secondary-expanded', expandSecondary.value)
  return expandSecondary.value;
};

function getNumberDisplay(value: number | undefined): string {
  return value?.toString() || '--';
}

function getReimbursementDisplay(value: number | undefined): string {
  return value ? `$${value.toFixed(2).toString()}` : '--';
}

function getTypeDisplay(value: string | undefined): string {
  switch (value) {
    case 'medical':
      return 'MED';
    case 'surgical':
      return 'SUR';
    default:
      return '--';
  }
}


return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_chip = _resolveComponent("q-chip")!

  return (_openBlock(), _createBlock(DualPane, {
    horizontal: "",
    vertical: "",
    disable: "",
    beforeClass: "drg-pane",
    afterClass: "drg-pane",
    separatorClass: "",
    expanded: props.showApr,
    secondaryVisible: props.enableDualGrouping,
    dark: "",
    onSecondaryExpanded: onSecondaryExpanded
  }, {
    primary: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_q_btn, {
          unelevated: "",
          class: "iodine-icon-button text-none",
          round: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_icon, {
              name: "fa-regular fa-edit",
              size: "18px"
            })
          ]),
          _: 1
        })
      ]),
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(primaryDRG).drg), 1),
        _hoisted_4,
        _createVNode(_component_q_chip, { class: "MCC" }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(primaryDRG).description), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(DisplayProperty, {
              label: "Weight",
              value: getNumberDisplay(_unref(primaryDRG).weight)
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(DisplayProperty, {
              label: "GMLOS",
              value: getNumberDisplay(_unref(primaryDRG).gmlos)
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(DisplayProperty, {
              label: "MDC",
              value: _unref(primaryDRG).mdc || '--'
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(DisplayProperty, {
              label: "Type",
              value: getTypeDisplay(_unref(primaryDRG).type)
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(DisplayProperty, {
              label: "Est. Reimbursement",
              value: getReimbursementDisplay(_unref(primaryDRG).reimbursement)
            }, null, 8, ["value"])
          ])
        ])
      ])
    ]),
    secondary: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_q_btn, {
          unelevated: "",
          class: "iodine-icon-button text-none",
          round: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_icon, {
              name: "fa-solid fa-arrows-rotate",
              size: "18px"
            })
          ]),
          _: 1
        })
      ]),
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(secondaryDRG).drg), 1),
        _hoisted_18,
        _createVNode(_component_q_chip, { class: "MCC" }, {
          default: _withCtx(() => [
            _hoisted_19
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createVNode(DisplayProperty, {
            label: "Weight",
            value: getNumberDisplay(_unref(secondaryDRG).weight)
          }, null, 8, ["value"]),
          _createVNode(DisplayProperty, {
            label: "GMLOS",
            value: getNumberDisplay(_unref(secondaryDRG).gmlos)
          }, null, 8, ["value"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["expanded", "secondaryVisible"]))
}
}

})